module.exports = __webpack_public_path__ + "img/logo-new.9666e8e8.png";